import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { DropDown, DropDownItem } from '../dropdown';

export const toppersNavList = [
  { label: 'Nu', pathname: '/toppers' },
  { label: 'Dag', pathname: '/toppers/dag' },
  { label: 'Week', pathname: '/toppers/week' },
  { label: 'Maand', pathname: '/toppers/maand' },
];

export const TopperSelection = ({ list = toppersNavList }) => {
  const location = useLocation();
  const activeItem = list.find((item) => item.pathname === location.pathname);
  return (
    <DropDown
      label={activeItem ? activeItem.label : list[0].label}
      isRight
      buttonProps={{ secondary: true }}
    >
      {list.map((option) => (
        <DropDownItem key={option.label} selectedValue={location.pathname === option.pathname}>
          <Link to={option.pathname}>{option.label}</Link>
        </DropDownItem>
      ))}
    </DropDown>
  );
};
